import { Component, ViewChild } from '@angular/core';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { SidenavService } from '../../../services/sidenav-service.service';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-landing-sidenav',
  standalone: true,
  imports: [
    MatSidenav,
    MatButtonModule,
    MatSidenavModule,
    CommonModule,
    MatIconModule
  ],
  templateUrl: './landing-sidenav.component.html',
  styleUrl: './landing-sidenav.component.scss'
})
export class LandingSidenavComponent {

  @ViewChild('sidenav') sidenav: MatSidenav;

  constructor(private sidenavService: SidenavService) {
  }

  ngAfterViewInit(): void {
    this.sidenavService.setSidenav(this.sidenav);
  }

  closeSidenav() {
    this.sidenavService.close();
  }

}
